import type { BasicPalette } from '@theme/theme.types'
import { styling as headingStyling } from '@lib/components/CRichTextEditor/extensions/headingExtended'
import { Paragraphs, styling as paragraphStyling } from '@lib/components/CRichTextEditor/extensions/paragraphExtended'

const addFontSizeStyle = (size: number): { fontSize: string } => ({
  fontSize: `${size}px`,
})

export const fontSizePresets = [12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 80, 120, 180]

export function exportObjectToGlobalCssProperties(colorPalette: Partial<BasicPalette>) {
  if (globalThis.document) {
    return Object.entries(colorPalette).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--p-${key}`, value)
    })
  }
}

export const textStylePresets = [
  {
    id: 'h_1',
    class: headingStyling[1].class,
    style: addFontSizeStyle(headingStyling[1].fontSize),
    value: 1,
  },
  {
    id: 'h_2',
    class: headingStyling[2].class,
    style: addFontSizeStyle(headingStyling[2].fontSize),
    value: 2,
  },
  {
    id: 'h_3',
    class: headingStyling[3].class,
    style: addFontSizeStyle(headingStyling[3].fontSize),
    value: 3,
  },
  {
    id: 'big_text',
    class: paragraphStyling[Paragraphs.BIG_TEXT].class,
    style: addFontSizeStyle(paragraphStyling[Paragraphs.BIG_TEXT].fontSize),
    value: Paragraphs.BIG_TEXT,
  },
  {
    id: 'normal_text',
    class: paragraphStyling[Paragraphs.NORMAL_TEXT].class,
    style: addFontSizeStyle(paragraphStyling[Paragraphs.NORMAL_TEXT].fontSize),
    value: Paragraphs.NORMAL_TEXT,
  },
  {
    id: 'small_text',
    class: paragraphStyling[Paragraphs.SMALL_TEXT].class,
    style: addFontSizeStyle(paragraphStyling[Paragraphs.SMALL_TEXT].fontSize),
    value: Paragraphs.SMALL_TEXT,
  },
]
